

export class VehicleDetailsInput implements IVehicleDetailsInput {
    /** The auto-generated id of the vehicle details master */
    vehicleDetailsId!: number;

    constructor(data?: IVehicleDetailsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleDetailsId = _data["vehicleDetailsId"];
        }
    }

    static fromJS(data: any): VehicleDetailsInput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDetailsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleDetailsId"] = this.vehicleDetailsId;
        return data; 
    }
}

export interface IVehicleDetailsInput {
    /** The auto-generated id of the vehicle details master */
    vehicleDetailsId: number;
}

